var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_2357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91419 12.5815C2.83385 12.5018 2.77008 12.407 2.72656 12.3025C2.68305 12.1981 2.66064 12.086 2.66064 11.9729C2.66064 11.8597 2.68305 11.7477 2.72656 11.6432C2.77008 11.5388 2.83385 11.444 2.91419 11.3643L7.29419 6.98431C7.31493 6.96432 7.33142 6.94036 7.34269 6.91385C7.35396 6.88734 7.35976 6.85883 7.35976 6.83003C7.35976 6.80122 7.35396 6.77271 7.34269 6.7462C7.33142 6.71969 7.31493 6.69573 7.29419 6.67574L2.91419 2.29574C2.83385 2.21606 2.77008 2.12126 2.72656 2.01681C2.68305 1.91235 2.66064 1.80032 2.66064 1.68717C2.66064 1.57402 2.68305 1.46198 2.72656 1.35753C2.77008 1.25308 2.83385 1.15828 2.91419 1.0786C3.07478 0.918953 3.29203 0.829346 3.51847 0.829346C3.74492 0.829346 3.96216 0.918953 4.12276 1.0786L8.96561 5.92145C9.20431 6.16362 9.33812 6.48999 9.33812 6.83003C9.33812 7.17006 9.20431 7.49643 8.96561 7.7386L4.12276 12.5815C3.96216 12.7411 3.74492 12.8307 3.51847 12.8307C3.29203 12.8307 3.07478 12.7411 2.91419 12.5815Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.07cd1b0d43480ac977f09129b036ddae.svg";
export { ForwardRef as ReactComponent };